

















import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { Component } from '@niknevis/vue-modules'
import { BaseRemoteDataUseCaseInterface } from '@/modules/shared/interfaces/base-remote-data-use-case.interface'


@Component({
  components: {
    DeleteConfirm,
    BaseButton
  }
})
export default class AdminCampaignDeleteButton extends Vue {
  @Prop({ required: true }) destroyUseCase!: BaseRemoteDataUseCaseInterface
  @Prop({ required: true }) id!: number
  @Prop({ default: 'حذف' }) label?: string

  sendDeleteRequest() {
    this.destroyUseCase.execute(this.id)
  }
}
